import { render, staticRenderFns } from "./DraggableComponent.vue?vue&type=template&id=644a4d0e&scoped=true&"
import script from "./DraggableComponent.vue?vue&type=script&lang=ts&"
export * from "./DraggableComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableComponent.vue?vue&type=style&index=0&id=644a4d0e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a4d0e",
  null
  
)

export default component.exports